export default __webpack_public_path__ + "static/media/play.46247e48.png";